import React from 'react'
import Header from './Header'
import Footer from './Footer'

const PrivacyPolicy = () => {
    return (
        <div className="app">
        <Header/>
        <div className="privacyPolicy">
            <h1>Polityka prywatności</h1>
            <br/><br/>
            <p>
                <strong>POLITYKA PRYWATNOŚCI I WYKORZYSTANIA PLIKÓW COOKIES</strong>
                <br/><br/> 

Ochrona prywatności osób odwiedzających naszą stronę internetową jest dla nas sprawą najważniejszą. 
Dlatego staramy się, aby zabezpieczyć dane osobowe osób odwiedzających naszą stronę internetową. 
Niniejsza polityka prywatności w jasny sposób wyjaśnia i przedstawia zasady i zakres przetwarzania danych osobowych.
 Zawiera także procedurę wykorzystywania plików cookies (ciasteczka).
  Stosowane są najnowocześniejsze środki organizacyjne i techniczne, zapewniające wysoki poziom ochrony przetwarzania
   danych osobowych.
    Polityka prywatności adresowana jest do wszystkich osób korzystających ze strony internetowej spedytorszkolenia.pl 
     Obowiązuje ona od 17 czerwca 2025 roku. 
<br/><br/>
<b>DEFINICJE:</b><br/><br/> 

1. Administrator – podmiot, który samodzielnie ustala cele i sposoby przetwarzania danych osobowych. 
Administratorem danych osobowych osób jest Krzysztof Wiśniewski ul.Derdowskiego 9/17 85-795 Bydgoszcz NIP 5541012980<br/>
<br/>
2. Dane osobowe – informacje o zidentyfikowanej lub możliwej do zidentyfikowania osobie fizycznej, 
<br/><br/>
3. Strona internetowa: https://spedytorszkolenia.pl <br/> 
<br/>
4. Podmiot przetwarzający – podmiot przetwarzający dane w imieniu administratora. 
<br/><br/>
5. RODO – Rozporządzenie Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób 
fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy
 95/46/WE, 
<br/><br/>
6. Odbiorca lub Użytkownik – osoby odwiedzające stronę internetową, 
<br/><br/>
7. Polityka – niniejsza polityka prywatności, obowiązująca od 17 czerwca 2025 roku. 
<br/><br/>
8. Pliki Cookies – dane informatyczne oraz  pliki tekstowe przechowywane na urządzeniach użytkowników 
(np. na komputerze, laptopie, smartfonie, tablecie lub telefonie) przesyłane przez strony internetowe.
<br/><br/>

<strong> KTO JEST ADMINISTRATOREM DANYCH OSOBOWYCH ORAZ JAK MOŻNA SIĘ Z NIM SKONTAKTOWAĆ? 
</strong><br/><br/>
Administratorem Danych Osobowych wszystkich użytkowników strony internetowej, 
w rozumieniu rozporządzenia Parlamentu Europejskiego i Rady (UE) z dnia 27 kwietnia 2016 r. 
w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych oraz  w sprawie swobodnego przepływu
 takich danych oraz uchylenia dyrektywy 95/46/WE (RODO) jest Krzysztof Wiśniewski ul. Derdowskiego 9/17 85-795 Bydgoszcz
  NIP 5541012980.
   W sprawach dotyczących przetwarzania danych osobowych można skontaktować się z administratorem danych osobowych
    za pomocą adresu mailowego: spedytorszkolenia@gmail.com 
    <br/><br/>

<strong>W JAKI SPOSÓB POZYSKUJEMY TWOJE DANE OSOBOWE I JAKI RODZAJ TWOICH DANYCH PRZETWARZAMY?</strong>
<br/><br/>

Twoje dane osobowe otrzymaliśmy od Ciebie w czasie wypełnienia formularza na naszej stronie www.
 Administrator przetwarza Twoje następujące dane osobowe:
 <br/><br/> 

a) imię i nazwisko, adres e-mail, informacje zawarte w treści wiadomości za pośrednictwem naszej strony
 oraz za pośrednictwem adresu e-mail, w tym treści komunikacyjne i metadane w celu wypełnienia formularza kontaktowego 
 i skontaktowania się z nami, <br/><br/>

b) imię i nazwisko, adres e-mail w celu skonfigurowania subskrypcji naszych e-maili lub newsletterów, 
<br/><br/>

c) w związku z wykorzystywaniem plików cookies będą to: informacje o komputerze 
(adres IP, lokalizacja geograficzna, typ i wersja przeglądarki, rodzaj systemu operacyjnego)
, informacje o wizytach oraz korzystaniu z naszej witryny 
(źródło odesłań, długość wizyty, wyświetlania stron i ścieżki nawigacji w witrynie),
 a także informacje, które generowane są podczas korzystania z naszej strony internetowej
  (kiedy, jak często i w jakich okolicznościach korzystasz z naszej strony internetowej, 
  <br/><br/>

Dodatkowo osadzamy widżet Facebooka, Instagrama, Tiktoka który pozwala Ci zobaczyć liczbę polubień,
 akcji, rekomendacji,  pozwala Ci także polubić, udostępnić oraz polecić nasze witryny internetowe.
  Ten widżet może zbierać takie dane jak: adres IP, typ i wersje przeglądarki, a również przechowywać
   i pobierać pliki cookies w przeglądarce.
    Osadzone zostaje dodatkowe śledzenie i monitorowanie interakcji z widżetem,
     w tym korelowanie kont z dowolnymi działaniami podejmowanymi w widgecie 
     tj. polubienie, udostępnienie, polecanie naszej strony internetowej.
      Aby uzyskać dodatkowe informacje na temat sposobu wykorzystania tych danych,
       zapoznaj się z politykami prywatności poszczególnych portali, 
       które znajdują się bezpośrednio na ich stronach internetowych. 
       <br/><br/>

<strong>W JAKIM CELU PRZETWARZAMY TWOJE DANE OSOBOWE? </strong><br/><br/>


Dane osobowe przesłane do nas za pośrednictwem naszej strony internetowej
 będą wykorzystywane do celów określonych w niniejszej polityce lub na odpowiednich stronach witryny.
  Twoje dane osobowe mogą być wykorzystywane do celów: <br/><br/>

• Komunikowania się z Tobą. Używamy Twoich danych osobowych w celu komunikowania się z Tobą za pośrednictwem Twojego adresu e-mail, 
<br/><br/>

• Wysyłania powiadomień e-mail. Używamy Twoich danych osobowych do wysyłania powiadomień, o które prosiłeś, 
<br/><br/>

• Zapewnienia bezpieczeństwa. Używamy Twoich danych osobowych do zapewnienia bezpieczeństwa strony internetowej,
 w tym weryfikacji zgodności z warunkami korzystania z naszej strony; w tym monitorowanie prywatnych wiadomości
  wysyłanych za pośrednictwem naszej prywatnej usługi przesyłania wiadomości, 
  <br/><br/>

• Zapobiegania oszustwom. Używamy Twoich danych osobowych w celu zapobiegania oszustwom 
i nadużyciom oraz ich wykrywania w celu ochrony bezpieczeństwa użytkowników, 
<br/><br/>

• Personalizacji. Używamy danych osobowych w celu personalizacji naszej strony dla Ciebie, 
<br/><br/>

• Rozpatrzenia skarg i zapytań. Używamy Twoich danych osobowych w celu rozpatrywania
 składanych przez Ciebie lub w związku z naszą witryną skarg, a także w celu odpowiedzi na kierowane przez ciebie pytania, 
<br/><br/>
• Umożliwienia korzystania ze strony internetowej. Używamy Twoich danych osobowych w celu umożliwienia korzystania
 z usług dostępnych na naszej stronie internetowej, 
 <br/><br/>

<b>NA JAKIEJ PODSTAWIE PRZETWARZAMY TWOJE DANE? </b><br/><br/>

Zgodnie z Rozporządzeniem Parlamentu Europejskiego i Rady (UE) z dnia 27 kwietnia 2016 r. 
w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych
 i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE przetwarzamy
  Twoje dane: 
  <br/><br/>
  a) Gdy przetwarzanie jest niezbędne do wypełnienia obowiązku prawnego (art. 6 ust 1 lit. c RODO).
   Administrator przetwarza Twoje dane osobowe m.in na podstawie
   <br/><br/>

a.)przepisów świadczenia usług drogą elektroniczną, 
<br/><br/>
b) Gdy przetwarzanie jest niezbędne do celów wynikających z prawnie uzasadnionych
 interesów realizowanych przez administratora (art. 6 ust. 1 lit. f RODO), 
<br/><br/>
c) Gdy przetwarzanie odbywa się na podstawie wyrażonej przez Ciebie zgody
 (art. 6 ust. 1 lit. a RODO). Zgoda na przetwarzanie Twoich danych osobowych 
 jest dobrowolna. Masz prawo wycofać zgodę w dowolnym momencie.
  Wycofanie zgody nie wpływa także na zgodność z przetwarzaniem, którego dokonano na podstawie zgody przed jej wycofaniem. 
<br/><br/>
<strong>
CZY UDOSTĘPNIAMY TWOJE DANE OSOBOWE? 
</strong><br/><br/>

Twoje dane osobowe udostępniane są podmiotom zależnym od administratora.
 Przestrzegają oni równie wysokiego standardu dbałości o bezpieczeństwo Twoich danych osobowych.
  Udostępnianie odbywa się w ściśle określonych celach i w sposób opisany poniżej: <br/><br/>

• Udostępniamy Twoje dane osobowe organom władzy publicznej oraz
 podmiotom realizującym zadania publiczne lub działających na zlecenie organów
  władzy publicznej, wyłącznie w zakresie i w celach, które wynikają z przepisów powszechnie obowiązującego prawa, 
  <br/><br/>

• Udostępniamy Twoje dane osobowe podmiotom współpracującym z administratorem, <br/><br/>

• Udostępniamy Twoje dane osobowe podmiotom realizującym zadania administratora m. in. dostawca oprogramowania, operator pocztowy,<br/><br/>

• Udostępniamy stronom trzecim informacje statystyczne o naszych użytkownikach; osoby trzecie nie mają możliwości identyfikacji żadnego konkretnego użytkownika na podstawie tych informacji.<br/><br/>
<strong>
 CZY PRZEKAZUJEMY TWOJE DANE DO PAŃSTW SPOZA EUROPEJSKIEGO OBSZARU GOSPODARCZEGO? 
 </strong><br/><br/>

W głównej mierze podmioty przetwarzające i gromadzące dane osobowe na naszej stronie internetowej pochodzą z Polski
 i krajów Europejskiego Obszaru Gospodarczego (EOG). 
 Poza EOG swoją siedzibę posiada jedynie podmiot współpracujący w zakresie 
 dostarczania usług statystycznych naszej strony internetowej, 
 który korzysta z narzędzia Google Analytics – Firma Google Inc. posiada swoją siedzibę w USA.
  Podmiot ten zobowiązany jest do przestrzegania zasad ujętych w programie Tarczy Prywatności UE – USA,
   które dotyczą gromadzenia, wykorzystywania oraz przechowywania danych osobowych obywateli Unii Europejskiej
    -w związku z decyzją wykonawczą Komisji (UE) 2016/1250 z dnia 12 lipca 2016 r. w sprawie adekwatności ochrony
     zapewnianej przez Tarczę Prywatności UE-USA, a także klauzul przyjętych przez Komisję UE. 
     <br/><br/>

<strong>JAK DŁUGO PRZETWARZAMY TWOJE DANE OSOBOWE? </strong><br/><br/>

Dane będziemy przechowywać przez okres niezbędny do realizacji powyższych celów; 
nie krócej niż przez okres wskazany w przepisach o archiwizacji
 lub innych przepisach prawa. Dokumenty elektroniczne zawierające dane osobowe zachowamy także, jeżeli: <br/><br/>

a) uznamy, że dane mogą mieć znaczenie dla wszelkich toczących się lub przyszłych postępowań sądowych, 
<br/><br/>
b) będą wymagać tego przepisy prawa, 
<br/><br/>
c) uznamy, że dane mogą mieć znaczenie w trakcie ustanowienia, wyegzekwowania lub obrony naszych praw. 
<br/><br/>
<strong>JAKIE MASZ PRAWA WOBEC PRZETWARZANIA DANYCH OSOBOWYCH?</strong><br/><br/>

Przetwarzanie Twoich danych osobowych wiąże się z koniecznością respektowania przysługujących Ci praw.
 Celem zapewnienia ich realizacji wyznaczyliśmy osobę do kontaktu, z którym możesz się kontaktować 
 wysyłając maila na adresy: spedytorszkolenia@gmail.com. <br/><br/>

Przysługuje ci:
<br/><br/>
• Prawo dostępu do Twoich danych osobowych. Skorzystanie z tego prawa umożliwia przekazanie Tobie informacji,
 czy przetwarzamy dane osobowe z Tobą związane, a jeżeli tak, przysługuje Ci wtedy prawo do otrzymania kopii
  danych osobowych. Dodatkowo pozwoli Ci również na zweryfikowanie tego, czy przetwarzamy Twoje dane zgodnie z prawem. 
  <br/>

• Prawo do sprostowania Twoich danych osobowych. Jeżeli zauważysz, że Twoje dane są niekompletne,
 nieprawdziwe lub nieaktualne masz możliwość żądania poprawienia wskazanych informacji.
  Pamiętaj, że realizując Twoje żądanie jesteśmy zobowiązani zweryfikować poprawność przekazanych nam nowych danych osobowych
   z Tobą związanych. 
<br/>
• Prawo do ograniczenia przetwarzania Twoich danych osobowych. Pamiętaj, że gdy wniesiesz sprzeciw wobec dalszego przetwarzania,
 musimy zweryfikować czy w dalszym ciągu mamy nadrzędne i prawnie uzasadnione podstawy do kontynuowania przetwarzania
  Twoich danych osobowych. 
  <br/><br/>

Skorzystanie z tego prawa pozwala Ci zażądać ograniczenia dalszego przetwarzania Twoich danych osobowych
 w następujących przypadkach: 
 <br/><br/>

✓ Gdy kwestionujesz prawidłowość swoich danych osobowych, <br/>

✓ Gdy okaże się, że nasze przetwarzanie nie jest zgodne z obowiązującymi przepisami prawa, <br/>

✓ Gdy Twoje dane są Ci potrzebne do ustalenia, dochodzenia lub obrony roszczeń. <br/>

• Prawo do usunięcia Twoich danych osobowych. Mamy obowiązek niezwłocznie usunąć Twoje dane osobowe: <br/>

✓ Gdy Twoje dane nie są już niezbędne do realizacji celów dla których zostały zebrane lub w inny sposób przetwarzane,<br/> 

✓ Gdy zrealizowałeś przysługujące Ci prawo do sprzeciwu wobec przetwarzania danych, <br/>

✓ Gdy cofnąłeś zgodę na podstawie której przetwarzaliśmy Twoje dane osobowe,<br/>

 ✓ Gdy przetwarzaliśmy Twoje dane niezgodnie z prawem lub jesteśmy zobowiązani do usunięcia
  Twoich danych osobowych w celu wywiązania się z obowiązku narzuconego przez obowiązujące przepisy prawa. <br/>
<br/>
Pamiętaj, że nie zawsze jesteśmy zobowiązani usunąć Twoje dane, w szczególności gdy przetwarzanie ich 
jest konieczne aby wypełnić obowiązek prawny.
<br/><br/> 

• Prawo do sprzeciwu wobec przetwarzania Twoich danych osobowych jest odpowiednie wtedy, kiedy uznasz,
 że przetwarzanie wpływa na Twoje prawa lub wolność. Prawo do sprzeciwu możesz uzasadnić związaną z
  Twoją osobą szczególną sytuacją z której wynika, że przetwarzanie Twoich danych osobowych łamie 
  Twoje prawa lub wolność. W niektórych szczególnych sytuacjach możemy wykazać, że posiadamy prawnie 
  uzasadnione podstawy do przetwarzania danych osobowych, które są nadrzędne wobec Twoich praw i wolności.
   Głównie w przypadku zapewnienia bezpieczeństwa strony internetowej oraz przeciwdziałanie oszustwom.
    W wskazanych przypadkach prawo to nie łączy się z prawem do usunięcia danych. 
    <br/><br/>

• Prawo do przenoszenia Twoich danych osobowych. Jeżeli chcesz otrzymać osobiście lub dostarczyć wskazanej przez
 Ciebie osobie trzeciej Twoje dane osobowe w powszechnym formacie nadających się do odczytu maszynowego 
 możesz skorzystać z prawa do przeniesienia Twoich danych. <br/><br/>

• Prawo do wniesienia skargi. Pamiętaj także, że masz prawo wnieść skargę w związku z przetwarzaniem przez 
nas Twoich danych osobowych do organu nadzorczego, którym jest Prezes Urzędu Ochrony Danych Osobowych 
(adres: Prezes Urzędu Ochrony Danych Osobowych, ul. Stawki 2, 00-193 Warszawa). 
Pomimo tego że masz prawo do skargi będziemy bardzo wdzięczni, jeżeli przed wniesieniem skargi, 
dasz nam szansę zająć się Twoją sprawą i wątpliwościami związanymi z przetwarzaniem przez nas Twoich danych osobowych.
 Z tego powodu bardzo prosimy o kontakt z Inspektorem Ochrony Danych Osobowych. <br/><br/>

<strong>JAK BEZPIECZNE SĄ INFORMACJE O MNIE? </strong><br/><br/>

✓ Staramy się o jak najwyższy poziom bezpieczeństwa użytkowników strony internetowej,
 dlatego nieustannie pracujemy nad zabezpieczeniem oraz ochroną Twoich danych osobowych
  podczas transmisji za pomocą specjalistycznych protokołów szyfrowania oraz dedykowanego oprogramowania. 
  <br/><br/>

✓ Na bieżąco organizujemy, utrzymujemy i aktualizujemy fizyczne, elektroniczne oraz proceduralne 
zabezpieczenia danych osobowych związane z pozyskiwaniem, przechowywaniem oraz ujawnieniem danych 
osobowych naszych użytkowników. Wdrożone zabezpieczenia dają Tobie najwyższy poziom poczucia bezpieczeństwa
 Twoich danych osobowych, <br/><br/>

✓ Wszystkie informacje o Tobie, które przetwarzamy, przechowujemy na odpowiednio zaszyfrowanych
 i zabezpieczonych serwerach. Administrator regularnie ocenia stopień bezpieczeństwa w ramach swojej
  sieci oraz dba o monitorowanie wewnętrznych regulacji i procedur zastosowanych po to, aby chronić
   dane przed wszystkimi możliwymi negatywnymi następstwami. <br/><br/>

✓ Pamiętaj, że nawet wdrożone najwyższe standardy bezpieczeństwa w oparciu o zastosowane 
najnowocześniejsze technologie nie dają całkowitego bezpieczeństwa Twoich danych osobowych 
w momencie udostępnienia informacji za pośrednictwem Internetu lub publicznie dostępnych sieci.
 Istnieje więc ryzyko, że dostęp do Twoich danych osobowych mogą uzyskać nieuprawnione do tego osoby trzecie. 
<br/><br/>
<strong>
WYKORZYSTYWANIE PLIKÓW COOKIES </strong><br/><br/>




Co to są pliki Cookies? To nic innego jak wszelkie dane informatyczne,
 w szczególności pliki tekstowe, które użytkownicy przechowują na swoich urządzeniach końcowych przesyłane przez różne
  strony internetowe. Cookies pozwalają rozpoznać Twoje urządzenie i odpowiednio wyświetlić stronę internetową dostosowaną
   do Twoich indywidualnych preferencji. Cookies przeważnie zawierają: nazwę strony internetowej z której pochodzą, 
<br/><br/>
W jakim celu używamy plików Cookies? 
<br/><br/>
Używamy plików Cookies i innych technologii (zwanych łącznie „plikami Cookies”), aby dokonać rozpoznania Twojej przeglądarki
 lub urządzenia i dowiedzieć się więcej o Twoich zainteresowaniach oraz zapewnić niezbędne funkcje. 
<br/><br/>
W szczególności używamy Cookies w celach m.in:<br/><br/>

 • Zapobiegania nieuczciwej działalności, <br />

• Poprawy bezpieczeństwa, <br />

• Raportowania (pozwoli nam to mierzyć i analizować wydajność naszych usług),
 Jakich plików Cookies używamy? W ramach strony internetowej stosujemy dwa zasadnicze
  rodzaje plików Cookies: „sesyjne” tzw. session cookies oraz „stałe” tzw. persisent cookies.
   Sesyjne Cookies są plikami tymczasowymi, które przechowywane są na Twoim urządzeniu do czasu
    wyłączenia przeglądarki internetowej. Stałe Cookies są przechowywane na Twoim urządzeniu przez
     określony czas w parametrach plików Cookies lub do czasu ich usunięcia przez Ciebie. 
     <br /><br />

W ramach strony internetowej stosowane są następujące rodzaje plików Cookies: <br /><br />

• Niezbędne – umożliwiają korzystanie z usług dostępnych w ramach strony internetowej np.
 pliki cookies uwierzytelniające – wykorzystywane do usług wymagających uwierzytelnienia w ramach strony internetowej,<br />

 • Wydajnościowe – umożliwiają zbieranie wszelkich informacji o metodzie korzystania ze strony internetowej, <br />

• Funkcjonalne – umożliwiają zapamiętanie wybranych przez Ciebie konfiguracji oraz personalizację Twojego 
interfejsu, np. w zakresie wybranego języka lub regionu, rozmiaru czcionki, wyglądu strony internetowej, itp., <br />

• Służące do zapewnienia bezpieczeństwa – wykorzystywane są do wykrywania nadużyć w zakresie uwierzytelnienia
 w ramach strony internetowej, Jakie zasady bezpieczeństwa powinien zastosować? Twoje urządzenie powinno być wyposażone
  w program antywirusowy z aktualną bazą definicji wirusów, aktualną i bezpieczną wersją przeglądarki 
  internetowej i włączoną zaporą sieciową „firewall”. Zalecane jest również włączenie w przeglądarce internetowej
   filtrów antyphishingowych, które sprawdzają, czy strona internetowa jest autentyczna i nie służy wyłudzaniu 
   informacji. Należy również uważać jakie załączniki otwieramy i w jakie odnośniki klikamy. Użytkownik powinien
    korzystać tylko z zaufanych sieci bezprzewodowych. <br /><br />

Czy pliki Cookies zawierają dane osobowe?<br /><br />

 Wprawdzie pliki Cookies nie zawierają oraz nie stanowią danych osobowych,
  jednakże niektóre informacje przechowywane w plikach Cookies np. preferencje,
   mogą być traktowane jako dane osobowe. Dane osobowe pozyskiwane przy użyciu plików Cookies mogą
    być przetwarzane, jedynie w celu wykonywania określonych funkcji na rzecz użytkownika w sposób
     przedstawiony powyżej. Dane takie są szyfrowane w sposób uniemożliwiający dostęp do nich osobom nieuprawnionym. 
     <br /><br />

Jak zapewniamy bezpieczeństwo? <br /><br />

Dla zachowania bezpieczeństwa przetwarzania Twoich danych osobowych używamy mechanizmów składowania
 i odczytu Cookies, które nie pozwalają na pobieranie żadnych poufnych informacji z Twojego Urządzenia.
  Przeniesienie z naszych serwerów jakichkolwiek wirusów, koni trojańskich i innych robaków na Twoje Urządzenie
   jest niemożliwe. Usuwanie plików Cookies i zmiana preferencji. Uprawnienia strony internetowej do przechowywania
    i uzyskiwania plików Cookies wynika z wyrażonej przez Ciebie zgody. Zgoda ta wyrażona jest podczas dokonywania
     konfiguracji przeglądarki internetowej lub podczas wejścia na stronę internetową. Masz możliwość konfigurowania
      w każdej chwili i w dowolny sposób swoich ustawień oraz określenia warunków przechowywania plików Cookies. 
      Standardowe oprogramowanie służące do przeglądania stron internetowych domyślnie dopuszcza umieszczenie plików 
      Cookies na urządzeniu końcowym. Możesz w każdej chwili samodzielnie zablokować automatyczną obsługę plików Cookies
       w ustawieniach przeglądarki. Poniżej dostępne są odnośniki do stron internetowych różnych przeglądarek z dokładnymi
        instrukcjami dotyczącymi Cookies, w tym sposoby ich usuwania:
        <br /><br /> • Google Chrome – https://support.google.com/chrome/answer/95647?hl=en <br /><br />
        • Mozilla Firefox – https://support.mozilla.org/pl/kb/usuwanie-ciasteczek 
        <br /><br />• Opera – https://help.opera.com/pl/latest/web-preferences/#cookies 
        <br /><br />• Edge – https://support.microsoft.com/pl-pl/help/10607/microsoft-edge-view-delete-browser-history 
        <br /><br />• Safari – https://support.apple.com/pl-pl/guide/safari/sfri11471/mac 
        <br /><br />• Internet Explorer – http://windows.microsoft.com/en-us/internet-explorer/delete-managecookies#ie=ie-11 
        <br /><br />Jeżeli wyłączysz wszystkie pliki Cookies w przeglądarce, ani my, ani osoby trzecie, nie przekażemy plików
        
         Cookies do przeglądarki. Jeżeli to zrobisz, konieczne może być ręczne dostosowanie niektórych preferencji każdorazowo
          odwiedzając stronę internetową, a niektóre funkcje i usługi mogą nie działać. Aby skorzystać do przysługującego Ci 
          prawa do sprzeciwu, które przyznaje RODO konieczne jest wylogowanie się ze wszystkich urządzeń i usunięcie z nich
           plików Cookies. Proces aktualizacji może potrwać nawet do 48 godzin. 
           <br /><br />

<strong>ZMIANA POLITYKI PRYWATNOŚCI</strong><br /><br />

 Polityka Prywatności może być przez nas zmieniana lub aktualizowana w szczególności w przypadku,
  gdy potrzeba lub obowiązek wprowadzenia zmian wynika ze zmiany przepisów prawa.
   Wszelkie istotne zmiany zostaną zamieszczone na tej stronie, a dodatkowo poinformujemy Cię o nich
    za pośrednictwem naszej strony internetowej.
<br /><br />
 <strong>POSTANOWIENIA KOŃCOWE</strong> <br/><br/>

Dodatkowe informacje na temat przetwarzania Twoich danych osobowych, 
w tym odpowiedzi na pytania dotyczące całego zakresu Polityki Prywatności,
 otrzymasz kontaktując się z administratorem oraz inspektorem ochrony danych osobowych. 
            </p>
        </div>
        <Footer/>
        </div>
    )
}

export default PrivacyPolicy
